module.exports = sana["lib"]["react"];